//#region src/object/flatten.ts
function flatten(object, options = {}) {
	const { prefix = "" } = options;
	const result = {};
	for (const [key, value] of Object.entries(object)) {
		const fullKey = prefix ? `${prefix}.${key}` : key;
		if (value !== null && typeof value === "object" && !Array.isArray(value)) Object.assign(result, flatten(value, { prefix: fullKey }));
		else result[fullKey] = value;
	}
	return result;
}
//#endregion
export { flatten };

//# sourceMappingURL=flatten.js.map